exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".loader {\n  border: 5px solid #ccc;\n  border-top: 5px solid #27DB9B;\n  border-radius: 50% !important;\n  width: 50px;\n  height: 50px;\n  animation: spin 2s linear infinite;\n  position: fixed;\n  top: calc(50% - 25px);\n  left: calc(50% - 25px); }\n\n@keyframes spin {\n  0% {\n    transform: rotate(0deg); }\n  100% {\n    transform: rotate(360deg); } }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader/lib/loader.js!./src/app/common/directives/spinner/spinner.component.scss
// module id = 71
// module chunks = 3